<template>

<!-- the four circles representing slots -->
  <div v-if="show" class="family-membership mol-color-theme-oscar-pool">

    <!-- members -->
    <div v-for="(member, index) in members" :key="`member-slot-${index}`" @click="showMemberModal(member)"
         class="member-slot"
         :class="{selectable: is_owner && (member._id !== userStore.getUserId())}"
         :title="member.username"
         data-bs-toggle="tooltip"
         data-bs-placement="bottom"
         data-bs-custom-class="member-slot-tooltip"
         data-bs-offset="0,10">
      <ProfilePicture :size="20" :user="member"/>
    </div>

    <!-- empty slots -->
    <template v-if="is_owner">

      <!-- show invite -->
      <div v-for="(invite, index) in membership.invite_codes" :key="`member-slot-${members.length + index}`" @click="showInviteModal(invite)"
           class="member-slot qr-code-slot selectable"
           title="share invite"
           data-bs-toggle="tooltip"
           data-bs-placement="bottom"
           data-bs-custom-class="member-slot-tooltip"
           data-bs-offset="0,10">
        <div class="add-member"><i class="fa fa-qrcode"></i></div>
      </div>

      <!-- create invite -->
      <div v-for="(slot, index) in num_empty_slots" :key="`member-slot-${members.length + invite_codes.length + index}`" @click="showInviteModal(null)"
           class="member-slot selectable"
           title="create invite"
           data-bs-toggle="tooltip"
           data-bs-placement="bottom"
           data-bs-custom-class="member-slot-tooltip"
           data-bs-offset="0, 10">
        <div class="add-member"><i class="fa fa-user-plus"></i></div>
      </div>
    </template>
  </div>

  <!-- member dialog, allowing the plan owner to remove them -->
  <GenericModal v-if="show_member_modal" @modal-closed="show_member_modal=false">
    <template #header>
      <h3>family plan member</h3>
    </template>

    <h5>
      <ProfilePicture :user="modal_member" :size="40"></ProfilePicture>  <ProfileName :user="modal_member" :hide_viewed_count="true"></ProfileName>
    </h5>

    <button class="btn btn-sm btn-mol remove-member-button" type="button" @click="removePlanMember(modal_member)">
      <span v-if="updatingMembership" class="spinner-border spinner-border-sm" role="status" ></span>
      <i v-else class="fa fa-user-times"></i> remove from plan
    </button>
    <!--
    <button class="btn btn-sm btn-outline-mol revoke-code-button" type="button" data-bs-dismiss="modal">
      cancel
    </button>
    -->
  </GenericModal>

  <!-- invite code dialog -->
  <GenericModal v-if="show_code_modal" @modal-closed="show_code_modal=false">
    <template #header>
      <h6>family plan invite code</h6>
    </template>

    <div v-if="modal_invite_code" style="text-align: center">
      <QRCodeVue3 :value="modal_invite_link"
                  :width="250" :height="250"
                  :image="logo"
                  :imageOptions="{margin: 2, imageSize: 0.25}"
                  :dotsOptions="{type: 'extra-rounded', color: '#b49823ff'}"
                  :cornersSquareOptions="{ color: '#b49823ff' }"
                  :cornersDotOptions="{ color: '#b49823ff' }"
                  :backgroundOptions="{ color: 'transparent' }"
                  :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'Q' }"
      />
      <div class="d-grid gap-2">
        <button class="btn btn-sm btn-block btn-mol copy-invite-link-button" type="button" @click="copyLinkToClipboard">
          <span v-if="!textCopied"><i class="fa fa-clipboard" aria-hidden="true"></i> copy link to clipboard
          </span>
          <span v-else>copied!</span>
        </button>
      </div>

      <button class="btn btn-sm btn-mol revoke-code-button" type="button" @click="revokeInviteCode(modal_invite_code)">
        <span v-if="updatingMembership" class="spinner-border spinner-border-sm" role="status" ></span>
        <i v-else class="fa fa-undo"></i> revoke code
      </button>

    </div>

    <div v-else class="generate-code">
      <p>Generate a unique code to share as an invitation to your family plan.</p>
      <button class="btn btn-sm btn-mol generate-code-button" type="button" @click="generateInviteCode()">
        <span v-if="updatingMembership" class="spinner-border spinner-border-sm" role="status" ></span>
        <i v-else class="fa fa-qrcode"></i> generate code
      </button>
    </div>

  </GenericModal>

</template>


<script>
import ProfilePicture from "@/components/profile/ProfilePicture.vue";
import {userStore} from "@/userStore";
import GenericModal from "@/components/modal/GenericModal.vue";
import QRCodeVue3 from "qrcode-vue3";
import analytics from "@/analytics";
import axios from "axios";
import ProfileName from "@/components/profile/ProfileName.vue";

export default {
  name: "FamilyMembershipWidget",
  components: {ProfileName, QRCodeVue3, GenericModal, ProfilePicture},
  emits: ['membership-updated'],
  props: ['membership'],
  data() {
    return {
      updatingMembership: false,

      show_code_modal: false,
      modal_invite_code: null,
      textCopied: false,

      show_member_modal: false,

    }
  },
  watch: {
    show_code_modal(showingModal) {
      // If we're closing the code modal, and there was actually a code beging shown, it's very possible we were
      //  showing it to someone who just scanned it an joined. So emit the membership-updated event.
      if ( !showingModal && this.modal_invite_code ) {
        this.$emit('membership-updated');
      }
    },
  },
  created() {
    //console.log('membership', this.membership);
  },
  computed: {
    userStore() {
      return userStore;
    },
    show() {
      return (this.membership?.lookup_key === 'family-membership');
    },
    logo() {
      return this.$imagePathBase + 'family-membership-qr-icon.png';
    },
    is_owner() {
      return this.membership?.owner === userStore.getUserId();
    },
    members() {
      // lets always display the owner first
      const ownerId = this.membership?.owner;
      return this.membership?.members.toSorted((m1, m2) => (m1._id === ownerId) ? -1 : (m2._id === ownerId) ? 1 : 0 ) || [];
    },
    invite_codes() {
      return this.membership?.invite_codes || [];
    },
    num_empty_slots() {
      return (4 - (this.members.length + this.invite_codes.length));
    },
    modal_invite_link() {
      return (this.modal_invite_code ? `${this.$apiPath}/family-membership-invite/${this.membership.stripe.subscription}/${this.modal_invite_code}` : null);
    }
  },
  methods: {
    async askForConfirmation(_message) {
      return new Promise((resolve, reject) => {
        try {
          const confirmed = window.confirm(_message);
          resolve(confirmed);
        } catch (err) {
          reject(err);
        }
      });
    },

    async generateInviteCode() {
      if ( !this.is_owner ) {
        return;
      }

      this.updatingMembership = true;

      return axios.post(`/api/membership/family-plan/generate-invite-code`, {
        subscription_id: this.membership.stripe.subscription
      })
          .then(response => {
            //console.log(`POST /family-plan/generate-invite-code`, response);
            this.showInviteModal(response.data);
            this.$emit('membership-updated');
          })
          .finally(() => {
            this.updatingMembership = false;
          });
    },

    async revokeInviteCode(_code) {
      if ( !this.is_owner ) {
        return;
      }

      this.updatingMembership = true;
      return axios.post(`/api/membership/family-plan/revoke-invite-code`, {
        subscription_id: this.membership.stripe.subscription,
        invite_code: _code
      })
          .then((/*response*/) => {
            //console.log(`POST /family-plan/revoke-invite-code`, response);
            this.showInviteModal(null);
            this.$emit('membership-updated');
            this.show_code_modal = false;
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.updatingMembership = false;
          });
    },

    showInviteModal(_code) {
      if ( !this.is_owner ) {
        return;
      }

      //console.log(`showInviteModal( ${_code} )`);
      this.modal_invite_code = _code;
      this.show_code_modal = true;
      this.textCopied = false;
    },

    copyLinkToClipboard() {
      if ( !this.is_owner ) {
        return;
      }

      navigator.clipboard.writeText(this.modal_invite_link);
      this.textCopied = true;
      analytics.sendEvent('family_plan_invite_code_copied');
    },

    showMemberModal(_member) {
      if ( !this.is_owner ) {
        return;
      }

      // don't show a modal for myself
      if ( _member._id === userStore.getUserId() ) {
        return
      }

      //console.log(`showInviteModal( ${_member._id} )`);
      this.show_member_modal = true;
      this.modal_member = _member;
    },

    async removePlanMember(_member) {
      if ( !this.is_owner ) {
        return;
      }

      try {
        const confirmed = await this.askForConfirmation(`Are you sure you want to remove ${_member.username} from your family plan?`);
        if ( confirmed ) {
          this.updatingMembership = true;
          await axios.post(`/api/membership/family-plan/remove-member`, {
            subscription_id: this.membership.stripe.subscription,
            remove_user: _member._id
          });
          this.$emit('membership-updated');
          this.show_member_modal = false;
        }
      }
      catch (err) {
        console.log(err);
      }
      this.updatingMembership = false;
    }
  }
}
</script>

<style>
.member-slot-tooltip {
  --bs-tooltip-bg: #b49823!important;
  --bs-tooltip-color: var(--bs-body-bg)!important;
  --bs-tooltip-opacity: 1.0!important;
  --bs-tooltip-arrow-height: 1em!important;
  font-size: x-small!important;

  @media (pointer: coarse) {
    display: none!important;
  }
}
</style>


<style scoped>
.family-membership {
  img {
    height:2.25em;
  }
  .member-slot {
    vertical-align: top;
    width: fit-content;
    display: inline-block;
    margin: 0.2em;

    border-radius: 50%;

    .add-member {
      border-style: solid;
      border-width: 0.01px;
      width:2.25em;
      height:2.25em;
      border-radius: 50%;

      .fa {
        vertical-align: bottom;
        &.fa-user-plus {
          margin-left: 15%;
          opacity: 40%;
        }
        &.fa-qrcode {
          font-size: 140%;
          margin-bottom: -14%;
        }
      }
    }

    &.selectable {
      &:hover {
        cursor: pointer;

        /*box-shadow: 0 0 3px 3px var(--mol-color-gold-faded);*/
        opacity: 50%;
        /*
        border-color: var(--mol-color-gold);
        background-color: var(--mol-color-gold-faded);
        */
      }
    }
  }
}

.generate-code {
  p {
    font-size: 18px;
  }

}

.generate-code-button {
  margin: 0px auto 40px auto;
  width: 230px;
  background-color: var(--mol-color-gold-text);
  color: var(--mol-color-gold-background);
  font-weight: 500;
}


.copy-invite-link-button {
  margin: 0 auto 40px auto;
  width: 230px;
  background-color: var(--mol-color-gold-text);
  color: var(--mol-color-gold-background);
  font-weight: 500;
}

.revoke-code-button {

  /*margin: 20px auto 20px auto;
  width: calc(230px * 50%);*/
  background-color: var(--mol-color-red-carpet-background);
  color: var(--mol-color-red-carpet);
  border-color: var(--mol-color-red-carpet);
  font-weight: 500;
}

.remove-member-button {
  margin: 20px auto 40px auto;
  background-color: var(--mol-color-red-carpet-background);
  color: var(--mol-color-red-carpet);
  border-color: var(--mol-color-red-carpet);
  font-weight: 500;
}


</style>